import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mode", "lodging", "transport"]

  connect() { this.update() }

  update() {
    const mode = this.modeTarget.value
    for (const kind of ["lodging", "transport"]) {
      const section = this[`${kind}Target`]
      const selected = mode === kind || mode === "both"
      section.hidden = !selected
      for (const input of section.querySelectorAll("textarea")) {
        input.disabled = !selected
        input.required = selected
      }
    }
  }
}
